export default __webpack_public_path__ + "static/media/good-punch.7f3d5d7f.mp3";